import React from 'react'

export const TreeContext = React.createContext()

export default function TreeContextProvider({ value, children }) {
  return <TreeContext.Provider value={value}>{children}</TreeContext.Provider>
}
